import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const FeriadoCivilService = {
  async postFeriado(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "civil/feriado",
      postData,
    );

    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }

    SnackBarModule("Feriado cadastrado com sucesso.", "success");
    return true;
  },

  async editarFeriado(postData, id) {
    postData.append("_method", "PUT");
    const response = await BaseService.fetchResponseFromAPIPost(
      `feriado/${id}`,
      postData,
    );

    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }

    SnackBarModule("Feriado cadastrado com sucesso.", "success");
    return true;
  },

  async getFeriados() {
    const response = await BaseService.fetchResponseFromAPIGet("feriados/civil");

    if(response.error) {
      SnackBarModule("Não foi possível buscar a lista de feriados.", "error");
    }

    return response.content;
  },
  async getFeriadosPadrao() {
    const response = await BaseService.fetchResponseFromAPIGet("feriados/padrao");

    if(response.error) {
      SnackBarModule("Não foi possível buscar a lista de feriados.", "error");
    }

    return response.content;
  },

  async deleteFeriado(id) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `feriado/${id}/delete`,
    );

    if (response.error) {
      SnackBarModule(
        "Não foi possível deletar o feriado.",
        "error",
      );
      return false;
    }

    SnackBarModule("O feriado foi deletado com sucesso", "success");
    return true;
  }
}